import request from "@/utils/request";

export function matingDesignGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/MatingDesign/GetAllForDropdown",
        method: "GET",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/mating_design.js